export function calculatePriceFromMargin(cost, profitMargin, precision = 2) {
  const costVal = parseFloat(cost);
  const marginVal = parseFloat(profitMargin);
  if (!isNaN(costVal) && !isNaN(marginVal) && marginVal >= 0) {
    const factor = Math.pow(10, precision);
    return Math.round(costVal * (1 + marginVal / 100) * factor) / factor;
  }
  return null;
}

export function calculateMarginFromPrice(price, cost, precision = 2) {
  const priceVal = parseFloat(price);
  const costVal = parseFloat(cost);
  if (!isNaN(costVal) && costVal > 0 && !isNaN(priceVal)) {
    const factor = Math.pow(10, precision);
    return Math.round(((priceVal - costVal) / costVal) * 100 * factor) / factor;
  }
  return null;
}

export function getItemSellingPrice(pi) {
  const price = Number(pi?.price);
  if (!isNaN(price)) {
    return price;
  }
  return Number(pi?.item?.price);
}

export function calculatePurchaseItemMargin(pi) {
  const costVal = Number(pi?.rate) || 0;
  const priceVal = getItemSellingPrice(pi);
  return costVal > 0 ? Math.round(((priceVal - costVal) / costVal) * 10000) / 100 : 0;
}

export function getLineTotal(purchaseItem) {
  const total = (Number(purchaseItem?.rate) || 0) * (Number(purchaseItem?.quantity) || 1);
  return Number(total) + (Number(purchaseItem?.tax) || 0);
}

const PurchaseHelper = {
  calculatePriceFromMargin,
  calculateMarginFromPrice,
  calculatePurchaseItemMargin,
  getItemSellingPrice,
  getLineTotal,
};

export default PurchaseHelper;
